'use strict';

if (app.PRODUCTION) {
  require('../stylesheets/app-prod.scss');
} else {
  require('../stylesheets/app-dev.scss');
}

function scrollTo(element) {
  let offset = $(element).offset().top;
  $('html, body').animate({ scrollTop: offset }, 500);
}

$(function() {

  $('[data-scrollto]').on('click', function(e) {
    e.preventDefault();
    let target = $(this).data('scrollto');
    scrollTo(target);
  });

  $('.js-section-toggle').on('click', function() {
    $(this).find('.js-section').slideToggle();
    console.log($(this).find('.js-section'))
  });

});
